import { requestAnimationFrame, getScrollX, getScrollY } from '../ADNDHelpers'
import { updateState } from '../ADNDState'

export const DRAG_LAYER_CLASS_NAME = 'drag-layer'
export const DRAG_LAYER_HIDDEN_CLASS_NAME = 'drag-layer-hidden'

export const DRAG_LAYER_STYLE = `.${DRAG_LAYER_CLASS_NAME} {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  pointer-events: none;
  user-select: none;
  z-index: 9000000;
  transition: none;
}
.${DRAG_LAYER_CLASS_NAME} * {
  pointer-events: none !important;
  user-select: none !important;
}
.${DRAG_LAYER_HIDDEN_CLASS_NAME}, .${DRAG_LAYER_HIDDEN_CLASS_NAME} * {
  visibility: hidden !important;
}
`

const props = {
  started: false,
  layerNode: null,
  styleNode: null,
  contentNode: null,
  className: null,
  width: null,
  height: null,
  hidden: true,
  lock: {
    x: null,
    y: null
  },
  offset: {
    x: 0,
    y: 0
  },
  cursor: {
    x: null,
    y: null
  },
  cloneNote: {
    operation: null,
    cloningNode: null,
    movingNode: null
  }
}

const LAYER = {
  updatesState: false,
  start(/*event*/) {
    if (!props.started) {
      // style node
      const styleNode = document.createElement('style')
      styleNode.type = 'text/css'
      if (styleNode.styleSheet) {
        styleNode.styleSheet.cssText = DRAG_LAYER_STYLE
      } else {
        styleNode.appendChild(document.createTextNode(DRAG_LAYER_STYLE))
      }

      // layer node
      const layerNode = document.createElement('div')
      LAYER.hide(layerNode)

      props.started = true

      // add to the body
      requestAnimationFrame(function () {
        if (props.started) {
          props.styleNode = styleNode
          props.layerNode = layerNode
          document.body.appendChild(props.styleNode)
          document.body.appendChild(props.layerNode)
        }
      })
    }
    return LAYER
  },
  stop(/*event*/) {
    if (props.started) {
      props.started = false
      props.contentNode = null
      props.cloneNote.cloningNode = null
      props.cloneNote.movingNode = null
      props.cloneNote.operation = null
      props.className = null
      props.width = null
      props.height = null
      props.hidden = true
      props.offset.x = 0
      props.offset.y = 0
      props.cursor.x = null
      props.cursor.y = null

      LAYER.lockX(null)
      LAYER.lockY(null)

      const styleNode = props.styleNode
      props.styleNode = null
      const layerNode = props.layerNode
      props.layerNode = null
      // remove from the body
      requestAnimationFrame(function () {
        if (null != layerNode && layerNode.parentNode == document.body) {
          document.body.removeChild(layerNode)
        }
        if (null != styleNode && styleNode.parentNode == document.body) {
          document.body.removeChild(styleNode)
        }
      })
    }
    return LAYER
  },
  isActive() {
    return props.started && null != props.contentNode
  },
  frame(state) {
    if (props.started && !props.hidden) {
      if (state.cursor.x != props.cursor.x || state.cursor.y != props.cursor.y) {
        props.cursor.x = state.cursor.x
        props.cursor.y = state.cursor.y
        LAYER.move(props.cursor.x, props.cursor.y)
      }
      if (props.cloneNote.operation != state.operation.type) {
        switch (state.operation.type) {
          case 'clone': {
            if (
              null != props.cloneNote.movingNode &&
              null != props.layerNode &&
              props.cloneNote.movingNode.parentNode == props.layerNode
            ) {
              props.layerNode.removeChild(props.cloneNote.movingNode)
            }
            if (null != props.cloneNote.cloningNode && null != props.layerNode) {
              props.layerNode.appendChild(props.cloneNote.cloningNode)
            }
            break
          }
          case 'move': {
            if (
              null != props.cloneNote.cloningNode &&
              null != props.layerNode &&
              props.cloneNote.cloningNode.parentNode == props.layerNode
            ) {
              props.layerNode.removeChild(props.cloneNote.cloningNode)
            }
            if (null != props.cloneNote.movingNode && null != props.layerNode) {
              props.layerNode.appendChild(props.cloneNote.movingNode)
            }
            break
          }
          default: {
            break
          }
        }
        props.cloneNote.operation = state.operation.type
      }
    }
    return state
  },
  move(x, y) {
    if (null != props.layerNode) {
      const layerX = null != props.lock.x ? props.lock.x : x + props.offset.x
      const layerY = null != props.lock.y ? props.lock.y : y + props.offset.y
      const translate = `translate(${layerX}px, ${layerY}px)`
      props.layerNode.style.webkitTransform = translate
      props.layerNode.style.mozTransform = translate
      props.layerNode.style.msTransform = translate
      props.layerNode.style.transform = translate
    }
    return LAYER
  },
  show(layerNode = props.layerNode) {
    if (null != layerNode) {
      layerNode.style.visibility = 'visible'
      layerNode.className = `${DRAG_LAYER_CLASS_NAME}${props.className ? ' ' + props.className : ''}`
      props.hidden = false
    }
    return LAYER
  },
  hide(layerNode = props.layerNode) {
    if (null != layerNode) {
      layerNode.style.visibility = 'hidden'
      layerNode.className = `${DRAG_LAYER_CLASS_NAME} ${DRAG_LAYER_HIDDEN_CLASS_NAME}${
        props.className ? ' ' + props.className : ''
      }`
      props.hidden = true
    }
    return LAYER
  },
  cloneContent({
    node,
    className,
    cursorX,
    cursorY,
    lockX,
    lockY,
    width: thisWidth,
    height: thisHeight,
    finalizeContent
  } = {}) {
    requestAnimationFrame(function () {
      if (null != props.layerNode) {
        const contentNode = node.cloneNode(true)
        const nodeRect = node.getBoundingClientRect()
        const width = thisWidth || nodeRect.width || nodeRect.right - nodeRect.left
        const height = thisHeight || nodeRect.height || nodeRect.bottom - nodeRect.top
        const scrollX = getScrollX()
        const scrollY = getScrollY()
        props.className = className

        LAYER.hide()

        props.width = width
        props.height = height
        props.layerNode.style.width = `${width}px`
        props.layerNode.style.height = `${height}px`
        props.layerNode.style.webkitTransform = null
        props.layerNode.style.mozTransform = null
        props.layerNode.style.msTransform = null
        props.layerNode.style.transform = null
        if (null != props.contentNode && props.contentNode.parentNode == props.layerNode) {
          props.layerNode.removeChild(props.contentNode)
        }
        props.contentNode = finalizeContent ? finalizeContent(contentNode) : contentNode
        props.layerNode.appendChild(props.contentNode)
        requestAnimationFrame(function () {
          if (null != props.layerNode && null != props.contentNode) {
            const rect = props.contentNode.getBoundingClientRect()
            const width = thisWidth || rect.width || rect.right - rect.left
            const height = thisHeight || rect.height || rect.bottom - rect.top
            props.width = width
            props.height = height
            updateState(function (state) {
              state.item.width = props.width
              state.item.height = props.height
              return state
            })
            props.layerNode.style.width = `${width}px`
            props.layerNode.style.height = `${height}px`
            props.offset.x = null != cursorX ? nodeRect.left + scrollX - cursorX : width >> 1
            props.offset.y = null != cursorY ? nodeRect.top + scrollY - cursorY : height >> 1
            LAYER.lockX(true === lockX ? Math.round(nodeRect.left + scrollX) : lockX)
            LAYER.lockY(true === lockY ? Math.round(nodeRect.top + scrollY) : lockY)

            LAYER.move(cursorX, cursorY).show()
          }
        })
      } else {
        requestAnimationFrame(function () {
          LAYER.cloneContent({ node, className, cursorX, cursorY, lockX, lockY, width: thisWidth, height: thisHeight })
        })
      }
    })

    return LAYER
  },
  updateContent(updater) {
    if (null != props.contentNode) {
      updater(props.contentNode)
    }
    return LAYER
  },
  useCloneNote({ cloningNode, movingNode } = {}) {
    props.cloneNote.cloningNode = cloningNode
    props.cloneNote.movingNode = movingNode
    return LAYER
  },
  lockX(value) {
    props.lock.x = null == value ? null : parseFloat(value)
    if (isNaN(props.lock.x)) {
      props.lock.x = null
    }
    return LAYER
  },
  lockY(value) {
    props.lock.y = null == value ? null : parseFloat(value)
    if (isNaN(props.lock.y)) {
      props.lock.y = null
    }
    return LAYER
  }
}

export default function ADNDDragLayer() {
  return LAYER
}
